
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPartlycloudyNightColour as ObiPartlycloudyNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-partlycloudy-night-colour.js';
 
 
 

 
 export const ObiPartlycloudyNightColour = createComponent({
   react: React,
   tagName: 'obi-partlycloudy-night-colour',
   elementClass: ObiPartlycloudyNightColourElement,
   events: {
     
   }
  });
 
 